import createReducer from '../createReducer';
import {TPromotionSummary} from './promotionSummary.type';

export const initialStatePromotionSummary: TPromotionSummary = {
    event: {
        stats: {revenue: 0, orders: 0, visits: 0, conversionRate: null, cost: 0},
        getPromotionSummaryXHR: null
    }
};

const reducer = createReducer('promotionSummary', initialStatePromotionSummary);

export default reducer;
